import { type FormEvent, memo, useState } from "react";
import EmailServerSettings from "Components/ConfigLayout/Event/EmailFtpSettings/EmailServerSettings";
import { Card, SettingsLayout, Tabs } from "@clintonelec/react-storybook";
import FtpServerSettings from "Components/ConfigLayout/Event/EmailFtpSettings/FtpServerSettings";
import ActionButtons from "Components/ConfigLayout/ActionButtons";
import EmailListSettings from "Components/ConfigLayout/Event/EmailFtpSettings/EmailListSettings";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import { selectEmailFtpSettings, setEmailFtpSettingsAction } from "Data/Redux/Slices/Settings/Event/EmailFtp";
import { isEqual } from "lodash";
import { produce } from "immer";

function EmailFtpSettings() {
	const dispatch = useAppDispatch();
	const emailFtpSettings = useAppSelector(selectEmailFtpSettings);
	const localEmailFtpState = useState(emailFtpSettings);
	const [ localEmailFtpSettings, setLocalEmailFtpSettings ] = localEmailFtpState;
	const setEmailFtpSettings = () => dispatch(setEmailFtpSettingsAction(localEmailFtpSettings));
	const disabled = isEqual(localEmailFtpSettings, emailFtpSettings)
		&& !emailFtpSettings.ftpServerSettings.password
		&& !emailFtpSettings.emailServerSettings.password;

	const panes = [
		{
			title: "Email Server",
			content: <EmailServerSettings localEmailFtpState={ localEmailFtpState }/>
		},
		{
			title: "Email List",
			content: <EmailListSettings localEmailFtpState={ localEmailFtpState }/>
		},
		{
			title: "FTP Server",
			content: <FtpServerSettings localEmailFtpState={ localEmailFtpState }/>
		}
	];

	const handleReset = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setLocalEmailFtpSettings(emailFtpSettings);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		setEmailFtpSettings();
		setLocalEmailFtpSettings(produce(localEmailFtpSettings, draft => {
			draft.ftpServerSettings.password = "";
		}));
	};

	return (
		<SettingsLayout.Form
			className="settings-form email-ftp-settings"
			noValidate
			onReset={ handleReset }
			onSubmit={ handleSubmit }
		>
			<SettingsLayout.ScrollableContainer>
				<Card size="medium" title="Email / FTP">
					<Tabs panes={ panes } />
				</Card>
			</SettingsLayout.ScrollableContainer>
			<ActionButtons disabled={ disabled } />
		</SettingsLayout.Form>
	);
}

export default memo(EmailFtpSettings);
